<template>
  <el-form ref="baseInfo" :rules="basicFormRules" :model="baseInfo" label-width="120px">
    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item
          :label="$t('salesBill.baseInfo.label.ladingCreateDate')"
          prop="ladingCreateDate"
        >
          <el-date-picker
            class="inputWidth"
            v-model="baseInfo.ladingCreateDate"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            :disabled="disabled"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$t('salesBill.baseInfo.label.ladingNo')" prop="ladingNo">
          <el-input v-model="baseInfo.ladingNo" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$t('salesBill.baseInfo.label.ladingCurrency')" prop="ladingCurrency">
          <!-- <ajax-select
            v-model="baseInfo.ladingCurrency"
            :apiUrl="currencyApi"
            :apiData="currencyData"
            :disabled="true"
            :clearable="true"
            valueKey="currencyCode"
            moreShowKey="currencyCode"
            labelKey="currencyName"
            method="get"
          ></ajax-select> -->
          <el-select
            class="inputWidth"
            :disabled="true"
            v-model="baseInfo.ladingCurrency"
            @change="changeCurrencyList"
            @focus="changFocus"
            @blur="changeBlur"
            filterable
            clearable
          >
            <el-option
              v-for="item in currencyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="baseInfo.currencyTypeName" disabled></el-input> -->
        </el-form-item>
      </el-col>
      <!-- 合同号 -->
      <el-col :span="6">
        <el-form-item :label="$t('salesBill.baseInfo.label.contractNo')" prop="contractNo">
          <el-input v-model="baseInfo.contractNo" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item
          :label="$t('salesBill.baseInfo.label.ladingBusinessDepartmentName')"
          prop="ladingBusinessDepartmentName"
        >
          <el-input v-model="baseInfo.ladingBusinessDepartmentName" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="业务员" prop="ladingSalesmanName">
          <el-input v-model="baseInfo.ladingSalesmanName" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="操作人" prop="ladingOperatorName">
          <el-input
            v-model="baseInfo.ladingOperatorName"
            maxlength="32"
            clearable
            disabled
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          :label="$t('salesBill.baseInfo.label.customerName')"
          prop="customerName"
          v-if="contractDetailCategory == 'HT08'"
        >
          <!--弹窗搜索-->
          <search-table
            v-model="baseInfo.customerNo"
            searchType="supplier"
            :disabled="disabled"
            :isMultiple="true"
            :extraData="extraDataCustomer"
            :currentValue="baseInfo.customerName ? baseInfo.customerName : ''"
            :checkRowKeys="baseInfo.customerNo ? [baseInfo.customerNo] : []"
            @input="(val) => chooseForm(val, 'customerName')"
          ></search-table>
          <!-- <el-button
            style="margin-left: 1%; height: 32px; width: 49%; float: right; padding: 9px 0px"
            type="primary"
            :disabled="false"
            @click="queryOrderLadingLimit()"
            >{{ $t('salePurchase.search.orderLadingLimit') }}</el-button
          > -->
        </el-form-item>
        <el-form-item
          :label="$t('salesBill.baseInfo.label.customerName')"
          prop="customerName"
          v-else
        >
          <el-input v-model="baseInfo.customerName" disabled></el-input>
          <!-- <el-button
            style="margin-left: 1%; height: 32px; width: 49%; float: right; padding: 9px 0px"
            type="primary"
            :disabled="false"
            @click="queryOrderLadingLimit()"
            >{{ $t('salePurchase.search.orderLadingLimit') }}</el-button
          > -->
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item :label="$t('salesBill.baseInfo.label.storageNo')" prop="storageNo">
          <!--弹窗搜索-->
          <search-table
            v-model="baseInfo.storageNo"
            searchType="warehouseDirectDeliver"
            :disabled="disabled"
            :isMultiple="true"
            :extraData="extraData"
            :currentValue="baseInfo.storageName ? baseInfo.storageName : ''"
            :checkRowKeys="baseInfo.storageNo ? [baseInfo.storageNo] : []"
            @input="(val) => chooseForm(val, 'storageNo')"
          ></search-table>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          :label="$t('salesBill.baseInfo.label.deliveryAddress')"
          prop="deliveryAddress"
        >
          <el-input
            v-model="baseInfo.deliveryAddress"
            maxlength="32"
            :disabled="disabled"
            clearable
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$t('salesBill.baseInfo.label.shippingMethod')" prop="shippingMethod">
          <ajax-select
            v-model="baseInfo.shippingMethod"
            :apiUrl="dictApi"
            :disabled="disabled"
            :apiData="deliveryMethodData"
          ></ajax-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$t('salesBill.baseInfo.label.deliveryDate')" prop="deliveryDate">
          <el-date-picker
            class="inputWidth"
            :disabled="disabled"
            v-model="baseInfo.deliveryDate"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="date"
            clearable
          ></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item label="提单总数量" prop="ladingTotalQuantity">
          <el-input v-model="baseInfo.ladingTotalQuantity" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6" prop="ladingTotalQuantityDesc" v-if="!isWuMaoAccount">
        <el-input v-model="baseInfo.ladingTotalQuantityDesc" disabled></el-input>
      </el-col>

      <el-col :span="6">
        <el-form-item
          :label="$t('salesBill.baseInfo.label.businessLadingTotalAmount')"
          prop="businessLadingTotalAmount"
        >
          <el-input v-model="baseInfo.businessLadingTotalAmount" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6" prop="ladingTotalAmountDesc" v-if="!isWuMaoAccount">
        <el-input v-model="baseInfo.ladingTotalAmountDesc" disabled></el-input>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item
          :label="$t('salesBill.baseInfo.label.lastestReceiveMoneyDay')"
          prop="lastestReceiveMoneyDay"
        >
          <el-date-picker
            class="inputWidth"
            :disabled="disabled"
            v-model="baseInfo.lastestReceiveMoneyDay"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="date"
            clearable
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$t('salesBill.baseInfo.label.receivingUnit')" prop="receivingUnit">
          <el-input
            v-model="baseInfo.receivingUnit"
            maxlength="32"
            :disabled="disabled"
            clearable
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          :label="$t('salesBill.baseInfo.label.ladingBusinessCompanyCode')"
          prop="ladingBusinessCompanyCode"
        >
          <el-input v-model="baseInfo.ladingBusinessCompanyCode" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          :label="$t('salesBill.baseInfo.label.ladingBusinessCompanyName')"
          prop="ladingBusinessCompanyName"
        >
          <el-input v-model="baseInfo.ladingBusinessCompanyName" disabled></el-input>
        </el-form-item>
      </el-col>
      <!-- 审批完成 -->
      <el-col :span="6" v-if="baseInfo.ladingStatus == 'TDZT03'">
        <el-form-item
          :label="$t('salesBill.baseInfo.label.nonInvoiceQuantity')"
          prop="nonInvoiceQuantity"
        >
          <el-input v-model="baseInfo.nonInvoiceQuantity" disabled></el-input>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="6" v-else>
        <el-form-item
          :label="$t('salesBill.baseInfo.label.ladingTotalQuantity')"
          prop="ladingTotalQuantity"
        >
          <el-input v-model="baseInfo.ladingTotalQuantity" disabled></el-input>
        </el-form-item>
      </el-col> -->
      <el-col :span="6" v-if="returnStatusName">
        <el-form-item :label="$t('salesBill.baseInfo.label.returnStatusName')">
          <span>{{ returnStatusName }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <!--  -->
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="项目" prop="projectInitiationNo">
          <el-input v-model="baseInfo.projectInitiationNo" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="项目简称" prop="projectInitiationName">
          <el-input v-model="baseInfo.projectInitiationName" disabled></el-input>
          <!-- <el-button
            style="margin-left: 1%; height: 32px; width: 39%; float: right; padding: 9px 0px"
            type="primary"
            :disabled="false"
            @click="queryProjectLadingLimit()"
            >项目可用额度查询</el-button
          > -->
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="基地简称" prop="baseName">
          <!--弹窗搜索-->
          <el-select
            filterable
            style="width: 100%"
            v-model="baseInfo.baseName"
            :disabled="disabled"
            :placeholder="this.$t('salesBill.baseInfo.label.baseNamePlaceholder')"
          >
            <el-option
              v-for="(item, index) in baseNameList"
              :key="index"
              :label="item.addressAbbreviation"
              :value="item.addressAbbreviation"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="平台公司名称" prop="platformCompanyName">
          <el-select
            filterable
            style="width: 100%"
            :disabled="disabled"
            v-model="baseInfo.platformCompanyName"
            @change="selectPlatformCompanyName"
            :placeholder="this.$t('salesBill.baseInfo.label.platformCompanyNamePlaceholder')"
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.personCompanyName"
              :value="item.personCompanyCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <!--  -->
    <el-row :gutter="24">
      <el-col :span="6" v-if="basicData.ladingStatus == 'TDZT03'">
        <el-form-item
          :label="$t('salesBill.baseInfo.label.amountDelivered')"
          prop="amountDelivered"
        >
          <el-input v-model="baseInfo.amountDelivered" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="basicData.ladingStatus == 'TDZT03'">
        <el-form-item
          :label="$t('salesBill.baseInfo.label.outstandingAmount')"
          prop="outstandingAmount"
        >
          <el-input v-model="baseInfo.outstandingAmount" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="自动生成关联提单号" prop="relationLadingFlag" class="lineLabel">
          <el-checkbox
            v-model="baseInfo.relationLadingFlag"
            :true-label="'1'"
            :false-label="'0'"
            :disabled="disabled"
            @change="changeRelationLadingFlag"
          ></el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="关联提单号" prop="relationLadingNo">
          <el-input v-model="baseInfo.relationLadingNo" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          label="关联提单的业务公司"
          prop="relationLadingBusinessCompanyCode"
          class="lineLabel"
        >
          <el-select
            filterable
            style="width: 100%"
            v-model="baseInfo.relationLadingBusinessCompanyCode"
            @change="selectCompany"
            :disabled="disabled || baseInfo.relationLadingFlag == '0'"
            :placeholder="
              this.$t('salesBill.baseInfo.label.relationLadingBusinessCompanyCodePlaceholder')
            "
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.personCompanyName"
              :value="item.personCompanyCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="关联销售合同号" prop="relationLadingSalesContractNo">
          <search-table
            v-model="baseInfo.relationLadingSalesContractNo"
            searchType="contract"
            :disabled="disabled || baseInfo.relationLadingFlag == '0'"
            :isMultiple="true"
            :extraData="{
              contractStatus: 'ZT03',
              contractCategory: 'sales',
              companyCode: null,
              departmentCode: null,
              customerNo: null,
              contractDetailCategory: 'CG04',
              contractBusinessCompanyNo: baseInfo.relationLadingBusinessCompanyCode,
            }"
            :currentValue="
              baseInfo.relationLadingSalesContractNo ? baseInfo.relationLadingSalesContractNo : ''
            "
            :checkRowKeys="
              baseInfo.relationLadingSalesContractNo ? [baseInfo.relationLadingSalesContractNo] : []
            "
            @input="(val) => chooseForm(val, 'relationLadingSalesContractNo')"
          ></search-table>
        </el-form-item>
      </el-col>
    </el-row> -->
    <!-- <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="关联提单的客户" prop="relationLadingCustomerName">
          <el-input v-model="baseInfo.relationLadingCustomerName" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          label="关联提单的客户收货单位"
          prop="relationLadingReceivingUnit"
          class="lineLabel"
        >
          <el-input
            v-model="baseInfo.relationLadingReceivingUnit"
            :disabled="disabled || baseInfo.relationLadingFlag == '0'"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row> -->
    <el-row :gutter="24">
      <el-col :span="24">
        <el-form-item label="备注" prop="mark">
          <el-input v-model="baseInfo.mark" :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
  import ajaxSelect from '@/components/form-item/ajax-select';
  import API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill.js';
  import DataBaseAPI from '@/api/dataBase';
  import { mapState } from 'vuex';
  //import * as RULES from "../rules/rules"; // 校验规则
  // import SearchModal from '@/components/SearchModal';
  import searchTable from '@/components/form-item/search-table';
  import { dateFormat } from '@/filters/index';
  // import DictSelect from '@/components/DictSelect';
  import ProjectApi from '@/api/purchaseSalesCenter/project.js';

  export default {
    props: {
      basicData: {
        type: Object,
        default: () => {},
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      returnStatusName: {
        type: String,
        default: '',
      },
      contractDetailCategory: {
        type: String,
        default: '',
      },
    },
    watch: {
      //监听部分字段变化 同步行信息
      'basicData.businessLadingTotalAmount': {
        handler(newValue) {
          this.baseInfo.businessLadingTotalAmount = newValue;
        },
        deep: true,
      },
      'basicData.businessLadingTotalAmountOther': {
        handler(newValue) {
          this.baseInfo.businessLadingTotalAmountOther = newValue;
        },
        deep: true,
      },
      'basicData.ladingTotalAmountDesc': {
        handler(newValue) {
          this.baseInfo.ladingTotalAmountDesc = newValue;
        },
        deep: true,
      },
      'basicData.ladingTotalQuantityDesc': {
        handler(newValue) {
          this.baseInfo.ladingTotalQuantityDesc = newValue;
        },
        deep: true,
      },
      'basicData.ladingTotalQuantity': {
        handler(newValue) {
          this.baseInfo.ladingTotalQuantity = newValue;
        },
        deep: true,
      },
      'basicData.exchangeRate': {
        handler(newValue) {
          this.baseInfo.exchangeRate = newValue;
        },
        deep: true,
      },
      'basicData.ladingCurrency': {
        handler(newValue) {
          this.baseInfo.ladingCurrency = newValue;
        },
        deep: true,
      },
      'basicData.nonInvoiceQuantity': {
        handler(newValue) {
          this.baseInfo.nonInvoiceQuantity = newValue;
        },
        deep: true,
      },
    },
    components: {
      ajaxSelect,
      // SearchModal,
      searchTable,
      // DictSelect,
    },
    data() {
      return {
        isDirectDeliverFlag: '',
        returnOldBurCurryCode: '',
        queryStorageNo: '',
        baseInfo: {},
        returnOldCurryCode: '',
        dictApi: API.DICT_LIST, // TODO 测试api
        dictApiData: {},
        instructionTypeData: {}, //交货方式
        deliveryMethodData: {}, //运输方式
        currencyData: {}, //货币种类
        isCreditsaleOptions: [
          { value: 1, label: this.$t('salesBill.search.yes') },
          { value: 0, label: this.$t('salesBill.search.no') },
        ],
        currencyApi: API.LIST_CURRENCY,
        deliveryMethodNumber: '',
        extraData: {
          adminFlag: this.userInfo?.adminFlag,
          currentStatus: 'ZT03', //已生效的仓库
        },
        currencyList: [],
        extraDataCustomer: {
          partnerTypes: 'HZHB03,HZHB01',
          requestStatus: 'ZT03',
          adminFlag: this.userInfo?.adminFlag,
          extendRequestDepartment: this.userInfo?.departmentCode,
        },
        contractExtraData: {
          contractStatus: 'ZT03',
          contractCategory: 'sales',
          companyCode: null,
          departmentCode: null,
          customerNo: null,
        },
        autoLadeDisable: true, //自动生成关联提单
        companyList: [], //公司列表
        baseNameList: [], //基地简称列表
      };
    },
    computed: {
      ...mapState({
        unitOptions() {
          return this.$baseRequest.getDictListByType('basic_unit');
        },
        // currencyList(state){
        //   return this.$baseRequest.getDictListByType("often_currency")
        // },
      }),
      basicFormRules() {
        return {
          ladingSalesmanName: [
            {
              required: true,
              message: this.$t('salesBill.baseInfo.label.pleaseChoose'),
              trigger: 'blur',
            },
          ],
          ladingBusinessDepartmentName: [
            {
              required: true,
              message: this.$t('salesBill.baseInfo.label.pleaseChoose'),
              trigger: ['blur', 'change'],
            },
          ],
          ladingBusinessCompanyCode: [
            {
              required: true,
              message: this.$t('salesBill.baseInfo.label.pleaseChoose'),
              trigger: ['blur', 'change'],
            },
          ],
          ladingBusinessCompanyName: [
            {
              required: true,
              message: this.$t('salesBill.baseInfo.label.pleaseChoose'),
              trigger: ['blur', 'change'],
            },
          ],
          storageNo: [
            {
              required: true,
              message: this.$t('salesBill.baseInfo.label.pleaseChoose'),
              trigger: ['blur', 'change'],
            },
          ],
          ladingCurrency: [
            {
              required: true,
              message: this.$t('salesBill.baseInfo.label.pleaseChoose'),
              trigger: ['blur', 'change'],
            },
          ],
          deliveryDate: [
            {
              required: true,
              message: this.$t('salesBill.baseInfo.label.pleaseChoose'),
              trigger: ['blur', 'change'],
            },
          ],
          /* shippingMethod: [
            {
              required: false,
              message: this.$t('salesBill.baseInfo.label.pleaseChoose'),
              trigger: ['blur', 'change'],
            },
          ], */
          lastestReceiveMoneyDay: [
            {
              required: true,
              message: this.$t('salesBill.baseInfo.label.pleaseChoose'),
              trigger: ['blur', 'change'],
            },
          ],
          relationLadingBusinessCompanyCode: [
            {
              required: this.baseInfo.relationLadingFlag == '1',
              message: this.$t('salesBill.baseInfo.label.pleaseChoose'),
              trigger: ['blur', 'change'],
            },
          ],
          relationLadingSalesContractNo: [
            {
              required: this.baseInfo.relationLadingFlag == '1',
              message: this.$t('salesBill.baseInfo.label.pleaseChoose'),
              trigger: ['blur', 'change'],
            },
          ],
          // baseName: [
          //   {
          //     required: true,
          //     message: this.$t('salesBill.baseInfo.label.pleaseChoose'),
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          platformCompanyName: [
            {
              required: true,
              message: this.$t('salesBill.baseInfo.label.pleaseChoose'),
              trigger: ['blur', 'change'],
            },
          ],
        };
      },
    },
    created() {
      const tenantCode = this.userInfo.tenantCode;
      this.instructionTypeData = { dictType: 'sale_instruction_type', tenantCode };
      this.deliveryMethodData = { dictType: 'delivery_method', tenantCode };
    },
    mounted() {
      const userInfo = this.userInfo;
      console.log(this);
      console.log(userInfo);
      this.baseInfo = Object.assign(
        {
          ladingOperatorNo: userInfo.userCode,
          ladingOperatorName: userInfo.userName,
          tenantCode: userInfo.tenantCode,
          companyCode: userInfo.companyCode,
          companyName: userInfo.companyName,
          departmentCode: userInfo.departmentCode,
          departmentName: userInfo.departmentName,
          ladingCreateDate: dateFormat(new Date()),
        },
        this.baseInfo,
        this.basicData,
        {
          ladingSalesmanNo: this.basicData.ladingSalesmanNo
            ? this.basicData.ladingSalesmanNo
            : userInfo.userCode,
          ladingSalesmanName: this.basicData.ladingSalesmanName
            ? this.basicData.ladingSalesmanName
            : userInfo.userName,
        }
      );
      this.getCompany();
      this.getCustomer();
      this.$nextTick(() => {
        this.$refs.baseInfo.clearValidate();
        this.getCurrencyList();
      });
    },
    methods: {
      //获取币别
      async getCurrencyList() {
        const selectStatus = await this.$axios.get(API.LIST_CURRENCY);
        if (selectStatus.data.code == 0) {
          selectStatus.data.data.map((item) => {
            let obj = {
              value: item.currencyCode,
              label: item.currencyName,
            };
            this.currencyList.push(obj);
          });
        }
      },
      // 选择公司代码
      selectCompany(v) {
        let companyObj = this.companyList.find((i) => i.personCompanyCode === v);
        this.baseInfo.relationLadingBusinessCompanyName = companyObj
          ? companyObj.personCompanyName
          : '';
      },
      // 选择公司代码
      selectPlatformCompanyName(v) {
        let companyObj = this.companyList.find((i) => i.personCompanyCode === v);
        this.baseInfo.platformCompanyName = companyObj ? companyObj.personCompanyName : '';
      },
      changeCurrencyList(val) {
        this.$emit('changeCurrencyList', val);
      },
      changFocus() {
        this.returnOldCurryCode = this.baseInfo.ladingCurrency;
      },
      changeBlur() {
        this.returnOldBurCurryCode = this.baseInfo.ladingCurrency;
      },
      setTotal(data) {
        this.baseInfo = Object.assign({}, this.baseInfo, data);
      },
      //交货方式变化影响 交货地址字段  当“交货方式”为“非直拨-客户自提”：默认为“仓库”的具体地址；其他情况用户输入
      deliveryMethodChange(val) {
        if (
          this.baseInfo.deliveryMethod == 'JHFS01' ||
          this.baseInfo.deliveryMethod == 'JHFS02' ||
          this.baseInfo.deliveryMethod == 'JHFS03' ||
          this.baseInfo.deliveryMethod == 'JHFS07'
        ) {
          //this.extraData.isDirectDeliver = "0"
        } else {
          //this.extraData.isDirectDeliver = "1"
        }
        if ('JHFS01' == val) {
          if (this.baseInfo.storageNo) {
            this.$axios.get(API.DETAIL_STORAGE_API + this.baseInfo.storageNo).then((res) => {
              if (0 == res.data.code) {
                this.baseInfo.deliveryAddress = res.data.data.storageAddress;
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            });
          }
        } else {
          this.baseInfo.deliveryAddress = '';
        }
        if (this.baseInfo.storageNo) {
          this.checkWareHouse();
        }
        this.$emit('deliveryMethodChange', this.baseInfo.deliveryMethod);
      },
      checkWareHouse() {
        this.$axios
          .get(`${API.CHECK_WAREHOUSE_BELONG_API}${this.baseInfo.storageNo}`)
          .then((res) => {
            if (res.data.code == 0) {
              this.isDirectDeliverFlag = res.data.data.isDirectDeliver;
              if (
                this.baseInfo.deliveryMethod == 'JHFS01' ||
                this.baseInfo.deliveryMethod == 'JHFS02' ||
                this.baseInfo.deliveryMethod == 'JHFS03' ||
                this.baseInfo.deliveryMethod == 'JHFS07'
              ) {
                this.deliveryMethodNumber = '0';
              } else {
                this.deliveryMethodNumber = '1';
              }
              if (
                this.isDirectDeliverFlag == null ||
                this.isDirectDeliverFlag != this.deliveryMethodNumber
              ) {
                //this.chooseForm(null, "storageNo")
              }
            }
          });
      },
      //获取公司信息
      async getCompany() {
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo;
        }
      },
      //获取立项信息的客户信息
      async getCustomer() {
        let params = {
          // projectInitiationNo: this.baseInfo.projectInitiationNo,
          contractNo: this.baseInfo.contractNo,
          departmentCode: this.userInfo.departmentCode,
        };
        await this.$axios.post(ProjectApi.CUSTOMER_ADDRESS, params).then((res) => {
          console.log(res, '1233333333333');
          if (res.data.code === 0) {
            this.baseNameList = res.data.data || [];
          }
        });
        // const projectList = await this.$axios.post(ProjectApi.PROJECT_List, params);
        // console.log(projectList, 'projectList');
        // if (projectList.data.code == 0 && projectList.data.data.records.length > 0) {
        /* let queryParam = {
            partnerCode: projectList.data.data.records[0].customerNo,
            adminFlag: 1,
            partnerZhName: projectList.data.data.records[0].customerName,
            selectAllPartner: 'Y',
            selectView: '00',
            maxNumberOfHits: 200,
          };
          const customerList = await this.$axios.post(DataBaseAPI.PARTNER_LIST_API, queryParam);
          if (customerList.data.code == 0) {
            const customer = await this.$axios.get(DataBaseAPI.GET_PARTNER, {
              id: customerList.data.data[0].id,
              partnerCode: customerList.data.data[0].partnerCode,
            });
            this.baseNameList = customer?.data.data.consigneeAddressList.map(
              (it) => it.addressAbbreviation
            );
          } */
        // const customer = await this.$axios.get(DataBaseAPI.LIST_GETPARTNERADDRESSINFO, {
        //   partnerCode: projectList.data.data.records[0].customerNo,
        // });
        // this.baseNameList = customer?.data.data.map((it) => it.addressAbbreviation);
        // }
      },
      //表单下拉表格赋值
      chooseForm(val, field) {
        if (field === 'storageNo') {
          //仓库
          const wareHouse = val ? val[0] : null;
          if (wareHouse) {
            this.baseInfo.storageNo = wareHouse.storageCode;
            this.queryStorageNo = wareHouse.storageCode;
            this.baseInfo.storageName = wareHouse.storageName;
            //if (this.baseInfo.deliveryMethod == 'JHFS01') {
            //非直拨-客户自提
            this.baseInfo.deliveryAddress = wareHouse.storageAddress;
            //  }
          } else {
            this.baseInfo.storageNo = '';
            this.baseInfo.storageName = '';
            //if (this.baseInfo.deliveryMethod == 'JHFS01') {
            //非直拨-客户自提
            this.baseInfo.deliveryAddress = '';
            //}
          }
          this.$emit('changeStorageNo', this.baseInfo.storageNo, this.baseInfo.storageName);
        }
        if (field === 'customerName') {
          //客户
          const customer = val ? val[0] : null;
          if (customer) {
            this.baseInfo.customerName = customer.partnerZhName;
            this.baseInfo.customerNo = customer.partnerCode;
          } else {
            this.baseInfo.customerNo = '';
            this.baseInfo.customerName = '';
          }
          this.$emit('changeCustomerNo', this.baseInfo.customerNo, this.baseInfo.customerName);
        }
        if (field === 'relationLadingSalesContractNo') {
          //客户
          const relationLadingSalesContract = val ? val[0] : null;
          if (relationLadingSalesContract) {
            this.baseInfo.relationLadingSalesContractNo = relationLadingSalesContract.contractNo;
            this.baseInfo.relationLadingCustomerName = relationLadingSalesContract.customerName;
            this.baseInfo.relationLadingCustomerNo = relationLadingSalesContract.customerNo;
          } else {
            this.baseInfo.relationLadingSalesContractNo = '';
            this.baseInfo.relationLadingCustomerName = '';
            this.baseInfo.relationLadingCustomerNo = '';
          }
        }
      },
      changeRelationLadingFlag() {
        if (this.baseInfo.relationLadingFlag == '0') {
          this.baseInfo.relationLadingBusinessCompanyCode = '';
          this.baseInfo.relationLadingBusinessCompanyName = '';
          this.baseInfo.relationLadingSalesContractNo = '';
          this.baseInfo.relationLadingCustomerName = '';
          this.baseInfo.relationLadingCustomerNo = '';
          this.baseInfo.relationLadingReceivingUnit = '';
        }
      },
      // queryCredit(){
      //   //信用额度
      //   if (!this.baseInfo.customerNo) {
      //     this.$message({
      //       showClose: true,
      //       message: this.$t("salePurchase.noCustomer"),
      //       type: "error"
      //     });
      //     return;
      //   }
      //   let path = {
      //     path: "/credit/statisticsList",
      //     name: "creditStatisticsList",
      //     meta: {
      //       keepAlive: true,
      //       title: "信用额度统计"
      //     },
      //     query: {
      //       partnerCode:  this.baseInfo.customerNo,
      //       validDate: dateFormatter(new Date()),
      //     }
      //   };
      //   this.$store.dispatch("tagsView/addTabView", path).then(() => {
      //     this.$nextTick(() => {
      //       this.$router.push(path);
      //     });
      //   });
      // },
      queryProjectLadingLimit() {
        //项目可用额度查询
        if (!this.baseInfo.customerNo) {
          this.$message({
            showClose: true,
            message: this.$t('salePurchase.noCustomer'),
            type: 'error',
          });
          return;
        }
        let path = {
          path: '/project/projectTotal',
          meta: {
            keepAlive: true,
            title: '项目额度统计',
          },
          query: {
            projectCode: this.baseInfo.projectInitiationNo,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      setSaleStorage(saleStorage) {
        this.baseInfo = Object.assign({}, this.baseInfo, saleStorage);
      },
      //校验
      validateAll() {
        //const errMap = await this.$refs.baseInfo.validate().catch(errMap => errMap);
        return new Promise((resolve, reject) => {
          this.$refs.baseInfo.validate((valid) => {
            valid ? resolve() : reject();
          });
        });

        // let formArr = ['baseInfo'];//两个表格
        // var resultArr = []//用来接受返回结果的数组
        // var _self = this
        // function checkForm(formName) { //封装验证表单的函数
        //   var result = new Promise(function (resolve, reject) {
        //     _self.$refs[formName].validate((valid) => {
        //       if (valid) {
        //         resolve();
        //       } else { reject() }
        //     })
        //   })
        //   resultArr.push(result) //push 得到promise的结果
        // }
        // formArr.forEach(item => { //根据表单的ref校验
        //   checkForm(item)
        // })
        // Promise.all(resultArr).then(function () { //都通过了
        //   return true
        // }).catch(function () {
        //   console.log("err");
        // });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .inputWidth {
    width: 100% !important;
  }
  ::v-deep .lineLabel .el-form-item__label {
    line-height: 18px;
  }
</style>
